import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './i18n/config'
import { ThemeProvider } from './contexts/ThemeContext'
import posthog from 'posthog-js'

const posthogKey = import.meta.env.VITE_POSTHOG_KEY
if (posthogKey) {
  posthog.init(posthogKey, {
    api_host: import.meta.env.VITE_POSTHOG_HOST ?? 'https://us.i.posthog.com',
    defaults: '2026-05-30', // pin SDK defaults to this release date — update when upgrading posthog-js
    person_profiles: 'identified_only',
    // Feedback is collected by our own Linear-backed widget (ENG-616), so the
    // PostHog survey tab must not render alongside it.
    disable_surveys: true,
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ThemeProvider>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </ThemeProvider>,
)
